import { Collapse, List, ListItem, ListItemButton, ListItemText, Box } from '@mui/material'
import { Link } from 'react-router-dom'
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { grey } from '@mui/material/colors';

const SettingsMenu = ({ collapse, setCollapse, open, sideBarData2, userData, selectedMenu, handleMenuClick, theme }) => {
    return (
        <Collapse in={collapse} timeout="auto" unmountOnExit sx={{ 
            padding: "0px 0px 0px 10px", 
            position: "fixed", 
            bottom: "20px", 
            width: "238px",
            backgroundColor: collapse ? "white" : "none"          
        }}>
            <ListItem disablePadding sx={{ display: 'block', fontSize: "12px", pb: 1 }}>
                <ListItemButton 
                    sx={{ 
                        borderRadius: "8px", 
                        fontWeight: 600, 
                        minHeight: 42,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: open ? 'flex-start' : 'center',
                        gap: open ? 2 : 0,
                        padding: open ? '8px 12px' : '8px',
                        transition: "all 0.3s ease",
                    }} 
                    onClick={() => setCollapse(!collapse)} 
                    disableRipple 
                    selected={collapse}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '24px',
                        height: '24px',
                    }}>
                        <span style={{ 
                            color: collapse 
                                ? theme?.palette?.primary?.main 
                                : theme.palette.mode === 'dark'         
                                    ? theme.palette.text.primary         
                                    : theme.palette.text.secondary,
                            transition: "color 0.3s ease"
                        }}>
                            <SettingsSuggestIcon />
                        </span>
                    </Box>
                    {open && (
                        <ListItemText 
                            primaryTypographyProps={{
                                variant: "body2",
                                fontWeight: selectedMenu === "Settings" ? 600 : 550,
                                fontSize: "0.8rem",
                                color: collapse ? "primary" : grey[600]
                            }} 
                            primary="Settings" 
                            sx={{ margin: 0 }}
                        />
                    )}
                    {open && (collapse ? <ExpandMore /> : <ExpandLess />)}
                </ListItemButton>
            </ListItem>
            <List sx={{ padding: "0px", overflowY: "auto", maxHeight: "200px" }}>
                {sideBarData2.map((res, id) => {
                    return (
                        <Link key={id} to={{ pathname: res?.route, state: res?.state }} style={{ color: theme.palette.mode === "dark" ? "white" : "black" }}>
                            {res?.show &&
                                <ListItem
                                    disablePadding
                                    sx={{ display: 'block', fontSize: "12px" }}
                                    onClick={() => handleMenuClick(res?.label, res?.route)}
                                >
                                    <ListItemButton
                                        selected={selectedMenu === res?.label}
                                        key={id}
                                        sx={{
                                            "&.Mui-selected": {
                                                backgroundColor: theme?.palette?.primary?.main + '20',
                                            },
                                            borderRadius: "8px", 
                                            fontWeight: 600,
                                            minHeight: 42,
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: open ? 'flex-start' : 'center',
                                            gap: open ? 2 : 0,
                                            padding: open ? '8px 12px' : '8px',
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '24px',
                                            height: '24px',
                                        }}>
                                            <span style={{ 
                                                color: selectedMenu === res?.label 
                                                    ? theme?.palette?.primary?.main 
                                                    : theme.palette.mode === 'dark'         
                                                        ? theme.palette.text.primary         
                                                        : theme.palette.text.secondary,
                                                transition: "color 0.3s ease"
                                            }}>
                                                {res?.icon}
                                            </span>
                                        </Box>
                                        {open && (
                                            <ListItemText 
                                                primaryTypographyProps={{
                                                    variant: "body2",
                                                    fontWeight: selectedMenu === res?.label ? 600 : 550,
                                                    fontSize: "0.8rem",
                                                    color: selectedMenu === res?.label ? "primary" : grey[600]
                                                }} 
                                                primary={res?.label} 
                                                sx={{ margin: 0 }}
                                            />
                                        )}
                                    </ListItemButton>
                                </ListItem>
                            }
                        </Link>
                    )
                })}
            </List>
        </Collapse>
    )
}

export default SettingsMenu
